import { styled } from '@mui/material/styles';

export const Header = styled('header')`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    box-sizing: border-box;
    background-color: white;
    height: 80px;
    padding: 0 24px;
`